import { Box, CircularProgress, styled } from '@mui/material';
import { BodyText } from '@/components/BodyText';
import { CopyButton } from '@/components/CopyButton/CopyButton';

const Row = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  minHeight: '24px',
  whiteSpace: 'nowrap',
});

const TraceId = styled(BodyText)({
  fontFamily: 'monospace',
  fontSize: '0.75rem',
  whiteSpace: 'nowrap',
});

const TraceIdLabel = () => (
  <BodyText color='text.secondary' fontSize='0.75rem'>
    Trace ID
  </BodyText>
);

export const TraceIdRow = ({ traceId }: { traceId: string }) => (
  <Row>
    <TraceIdLabel />
    <TraceId color='text.secondary' data-testid='failure-trace-id'>
      {traceId}
    </TraceId>
    <CopyButton text={traceId} tooltip='Copy trace ID' />
  </Row>
);

export const TraceIdLoadingRow = () => (
  <Row data-testid='failure-trace-id-loading'>
    <TraceIdLabel />
    <CircularProgress size={12} sx={{ color: 'text.secondary', marginLeft: '4px' }} />
    <BodyText color='text.secondary' fontSize='0.75rem'>
      Looking up trace ID
    </BodyText>
  </Row>
);
